module.exports = __webpack_public_path__ + "img/bunny.1454375c.gif";